<template>
  <v-dialog v-model="editDialog" class="the-app-dialogs" persistent max-width="550px">
    <v-card>
      <form @submit.prevent="validateBeforeSubmit($event)">
        <v-layout row class="no-select" style="background-color:#09132f">
          <h3 id="dialog-title" class="text-uppercase px-3 pt-3" style="text-xs-center letter-spacing:2px">
            <v-layout align-center>
              <v-icon light x-large class="rgba(0,0,0,0.3)--text pb-1">attach_money</v-icon>
              <span class="px-3">{{ $t(`Edit Currency Exchange's Information`) }}</span>
            </v-layout>
          </h3>
          <v-spacer />
          <v-card-actions>
            <v-btn fab icon dark @click="$emit('hidemodal')">
              <v-icon>close</v-icon>
            </v-btn>
          </v-card-actions>
        </v-layout>

        <v-card-title class="grey lighten-3">
          <v-layout row wrap>
            <v-flex xs12 pa-2>
              <p>{{ `${$t('Exchange Type')} *` }}</p>
              <v-radio-group v-model="viewInfo.exchange_type" name="exchange_type" v-validate="'required'" row>
                <v-radio :label="$t('To Dinar')" value="To Dinar" color="blue" />
                <v-radio :label="$t('To Dollar')" value="To Dollar" color="blue" />
              </v-radio-group>
            </v-flex>

            <v-flex xs12 class="pa-2">
              <v-text-field
                v-model="viewInfo.amount_us"
                :label="`${$t('Amount (USD)')} *`"
                name="amount_us"
                box
                hide-details
                background-color="white"
                :error="errors.has('amount_us')"
                v-validate="'required|min_value:0'"
                @input="toDinar()"
              />
            </v-flex>

            <v-flex xs12 class="pa-2">
              <v-text-field
                v-model="viewInfo.amount_iq"
                :label="`${$t('Amount (IQD)')} *`"
                name="amount_iq"
                box
                hide-details
                background-color="white"
                :error="errors.has('amount_iq')"
                v-validate="'required|min_value:0'"
                @input="toDollar()"
              />
            </v-flex>
          </v-layout>
        </v-card-title>

        <v-divider light />

        <v-card-actions class="grey lighten-3">
          <v-layout column>
            <v-flex xs12 class="pb-2 px-2" style="color: #444;"
              >- {{ $t('Fields marked with asterisk ( * ) are required.') }}</v-flex
            >

            <v-layout justify-end>
              <v-btn outline color="primary" @click="$emit('hidemodal')">{{ $t('Cancel') }}</v-btn>
              <v-btn type="submit" color="success" :loading="btnUpdateLoading">
                <v-icon :right="$vuetify.rtl" :left="!$vuetify.rtl">save</v-icon>
                {{ $t('Update') }}
              </v-btn>
            </v-layout>
          </v-layout>
        </v-card-actions>
      </form>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'edit-component',

  props: {
    editDialog: { type: Boolean, required: true }
  },

  data() {
    return {
      systemCurrency: localStorage.systemCurrency,
      btnUpdateLoading: false
    }
  },

  computed: {
    ...mapGetters({
      viewInfo: 'currencyExchanges/getCurrencyExchangeInfo'
    })
  },

  watch: {
    editDialog: {
      immediate: false,
      handler() {
        if (this.editDialog) {
          this.addEscKeyListener()
        }
      }
    }
  },

  methods: {
    ...mapActions({
      updateCurrencyExchangeInfo: 'currencyExchanges/updateCurrencyExchangeInfo'
    }),

    addEscKeyListener() {
      document.addEventListener('keyup', e => {
        // if the "ESC" button was pressed and this dialog is shown, hide it
        if (e.keyCode === 27 && this.editDialog) {
          this.$emit('hidemodal')
        }
      })
    },

    toDollar() {
      this.viewInfo.amount_us = Number((this.viewInfo.amount_iq / this.viewInfo.dollar_price).toFixed(2))
    },

    toDinar() {
      this.viewInfo.amount_iq = Number((this.viewInfo.amount_us * this.viewInfo.dollar_price).toFixed(2))
    },

    validateBeforeSubmit(event) {
      this.$validator.validateAll().then(() => {
        if (!this.errors.any()) {
          this.btnUpdateLoading = true

          let formData = new FormData(event.target)
          formData.append('dollar_price', this.viewInfo.dollar_price)

          // for (let pair of formData.entries()) {
          //   console.warn(`${pair[0]}: ${pair[1]}`)
          // }

          let payload = { id: this.viewInfo.exchange_id, formData }

          this.updateCurrencyExchangeInfo(payload)
            .then(() => {
              this.btnUpdateLoading = false
              this.$emit('updated')
            })
            .catch(() => {
              this.btnUpdateLoading = false
            })
        }
      })
    }
  }
}
</script>

<style scoped></style>
